<ng-container *ngIf="errorDetailsService.ErrorMessagesQueue?.length">
    <div class="d-block error row" data-bs-toggle="collapse" href="#collapseFour" aria-expanded="false"
        aria-controls="collapseFour">
        <div class="message d-flex col-10">
            <img src="assets/icons/error.svg" alt="">
            <p class="mx-1 my-0 message">{{errorDetailsService.ErrorMessagesQueue[0].Title | translate}}</p>
        </div>
        <div class="details justify-content-end align-items-center col-2 d-flex">
            <i class="fa-solid fa-chevron-down"></i>
            <button class="close d-block" (click)="closeAll()">{{'DismissAll' | translate}}</button>
        </div>
    </div>
    <div class="collapse" id="collapseFour" aria-labelledby="headingFour" data-bs-parent="#custom-accordion-one">
        <div class="error row" *ngFor="let res of errorDetailsService.ErrorMessagesQueue">
            <div class="d-flex col-10">
                <img src="assets/icons/error.svg" alt="">
                <p class="mx-1 my-0 message"> {{res.Title | translate}} </p>
            </div>
            <div class="details justify-content-end align-items-center col-2 d-flex flex-nowrap">
                <button class="error-details d-block" *ngIf="res.Details" (click)="details(res.Id)">{{'ErrorDetails' |
                    translate}}</button>
                <button class="close d-block" (click)="close(res.Id)">X</button>
            </div>
        </div>
    </div>
</ng-container>
<lib-side-bar-error-details *ngIf="currentError" [error]="currentError"></lib-side-bar-error-details>